/**
 * Guide tab labels. Almost all handbook copy lives in ./content.ts; this
 * module holds only the section headers, table labels, and action labels
 * that are specific to the Guide screen's layout.
 */
export const guide = {
  title: 'Guide',
  subtitle: 'Your handbook for the first weeks',

  expect: {
    section: 'What to expect',
    tableTitle: 'Day by day',
    tableCaption: 'Daily minimums for wet and dirty diapers, and typical amounts per feeding.',
    colDay: 'Day',
    colWet: 'Wet',
    colStool: 'Dirty',
    colIntake: 'Per feed',
    dayPlus: (day: number) => `${day}+`,
    atLeast: (n: number) => `${n}+`,
    range: (min: string, max: string) => `${min} to ${max}`,
  },

  visits: {
    section: 'Your visit plan',
  },

  reach: {
    call: (phone: string) => `Call ${phone}`,
    text: (phone: string) => `Text ${phone}`,
  },

  mood: {
    crisisTitle: 'If you need help right now',
    call988: 'Call 988',
    text988: 'Text 988',
    callPsi: 'Call PSI: 1-800-944-4773',
  },
};
